<div class="main-content">
  <div class="container-fluid">

    <loader *ngIf="loading"></loader>

    <ng-container *ngIf="!loading">

      <div class="admin-page-header">
        <h3>
          Evaluator
          <span *ngIf="epe.sop_status" class="label epe-status-badge" [ngClass]="getStatusBadgeClass(epe.sop_status)"
                style="font-size:13px; vertical-align:middle; margin-left:10px;">
            {{ getStatusLabel(epe.sop_status) }}
          </span>
        </h3>
        <p class="text-muted">User&nbsp;#{{ epe.id }}</p>
      </div>

      <!-- Score block (if voted) -->
      <div *ngIf="isVoted(epe)" class="score-summary">
        <div class="score-block">
          <span class="score-num">{{ truncateFloat(epe.score!) }}</span>
          <span class="score-meta">/ 10</span>
        </div>
        <span class="score-votes">{{ epe.nvotes }} vote(s)</span>
        <span *ngIf="isWarning(epe)" class="label label-warning" style="margin-left:8px;">
          <i class="fa fa-exclamation-triangle"></i> High variance
        </span>
      </div>

      <div class="row">
        <!-- Detail card -->
        <div class="col-md-8">
          <div class="detail-card">
            <div class="detail-card-body">
              <epe-sopcard [vote]="voteChangeDetectorValue" [epe]="epe"></epe-sopcard>
            </div>
          </div>
        </div>

        <!-- Action panel -->
        <div class="col-md-4">
          <div class="detail-card">
            <div class="detail-card-body">
              <epe-sopcard-small (voteUpdated)="voteChangeDetector($event)" [epe]="epe"></epe-sopcard-small>
            </div>
          </div>
        </div>
      </div>

      <div style="margin-top: 20px;">
        <a routerLink="/epes" class="back-link">
          <i class="fa fa-arrow-left"></i> Back to Evaluators
        </a>
      </div>

    </ng-container>

  </div>
</div>
<simple-alert [message]="alertMessage" [alert]="alertType" [(show)]="showAlert"></simple-alert>
